import classNames from 'classnames'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Images from '@/components/Images'

const HeroHomepage = ({
  backgroundColors,
  headingTag,
  heading,
  content,
  buttons = [],
  images = [],
  videoHevc,
  videoWebm,
  _editable,
}) => {
  const HeadingTag = headingTag || 'p'

  const hasVideo = (videoHevc && videoHevc.filename) || (videoWebm && videoWebm.filename)

  return (
    <section
      {...makeEditable(_editable)}
      className={classNames('relative overflow-hidden py-12', backgroundColors.current)}
    >
      <Grid className='from-purple-600 to-blue-600 bg-gradient-to-r'>
        <div className='col-span-full row-start-1 flex flex-col justify-center md:col-span-6 lg:col-span-6'>
          <HeadingTag>
            <Heading heading={heading} />
          </HeadingTag>

          <Content content={content} className='mb-8 mt-20' />
          <Buttons
            buttons={buttons}
            className='mb-12 flex flex-col items-start gap-x-2 gap-y-4 md:mb-17 md:flex-row'
          />
        </div>
        <div className='relative col-span-full lg:col-start-7'>
          {!hasVideo && (
            <Images
              className='aspect-h-10 aspect-w-9'
              images={images}
              imageProps={{fitIn: true, ratio: '9:10', sizes: {sm: 50}, loading: 'eager'}}
            />
          )}

          {hasVideo && (
            <div className='aspect-h-10 aspect-w-9'>
              <video autoPlay loop muted playsInline preload='auto'>
                <source src={videoHevc.filename} type='video/mp4; codecs="hvc1"' />
                <source src={videoWebm.filename} type='video/webm' />
              </video>
            </div>
          )}
        </div>
      </Grid>
    </section>
  )
}

export default HeroHomepage
